import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import Chatbot from './pages/Chatbot';
import ProtectedRoute from './components/ProtectedRoute';
import UpgradePage from './pages/UpgradePage'; // 1. Import the new UpgradePage

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/mentorai"
          element={
            <ProtectedRoute>
              <Chatbot />
            </ProtectedRoute>
          }
        />
        {/* 2. Add the new protected route for the upgrade page */}
        <Route
          path="/upgrade"
          element={
            <ProtectedRoute>
              <UpgradePage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;